import { render } from "./InfoCircleSvg.vue?vue&type=template&id=2df07b4e"
import script from "./InfoCircleSvg.vue?vue&type=script&lang=js"
export * from "./InfoCircleSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__